export const isAuthorMode = () => {
  return document.body.hasAttribute('data-edit-mode')
}
